import FeaturedAuthorBlock from './featuredAuthorBlock'

export default FeaturedAuthorBlock
